"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocaleFromCountryCode = void 0;
const mapCountryCodeToLocale = {
    gr: 'el',
    il: 'he' // Israel -> Hebrew
};
function getLocaleFromCountryCode(countryCode) {
    return mapCountryCodeToLocale[countryCode.toLowerCase()];
}
exports.getLocaleFromCountryCode = getLocaleFromCountryCode;
//# sourceMappingURL=getLocaleFromCountryCode.js.map